import { MAHALLE_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const mahalleList = () => {
    const data = {};
    return getRequest({url:MAHALLE_LISTESI,data});
}

export default mahalleList;